import { useQuery } from '@mint-lib/query-client';
import { useFlags } from '@mint-lib/routing-context';
import { EmailIntegrations } from '@mint-sdk/api-integrations';

export const useGetEmails = (integration: string) => {
  const { newGhostEmailApi } = useFlags('@mint/arm', ['newGhostEmailApi']);

  const isNewApiEnabled = newGhostEmailApi.enabled;

  //TODO: Remove useQuery when newGhostEmailApi FF  is enabled on PROD
  const { data: oldData = [], isLoading: oldIsLoading } = useQuery({
    ...EmailIntegrations.get({
      params: {
        integrationId: integration,
      },
    }),
    enabled: !isNewApiEnabled,
  });

  const { data: newData = [], isLoading: newIsLoading } = useQuery({
    ...EmailIntegrations.getV2({
      params: {
        platformName: integration,
      },
    }),
    enabled: isNewApiEnabled,
  });

  return {
    data: isNewApiEnabled ? newData : oldData,
    isLoading: isNewApiEnabled ? newIsLoading : oldIsLoading,
  };
};
